import baseHttp from './baseHttp';

// Craft swaps in the draft when its live preview token reaches the API
const previewToken = () => {
    const token = new URLSearchParams(window.location.search).get('token');
    return token ? { token } : {};
};

export const getHttp = async (
    url,
    params,
    options,
) => baseHttp(url,
    'get',
    {
        ...options,
        params: { ...params, ...previewToken() }
    });

export const postHttp = async (
        url,
        data,
        options,
    ) => baseHttp(url,
        'post',
        {
            data,
            ...options
        });
